<template>
    <div style="min-height: 70vh;" class="">

        <div class="col-sm-12 tabs pb-3 bold">
            <!-- <ul class="border-top-0">
                <li v-for="(tab, number) in tabs" @click="changeTab(number)" :class="(activeTab == number) ? 'active' : ''">
                    {{ tab }}
                </li>
            </ul> -->
            <!-- <div class="col-sm-12 mt-3"> -->
                <div class="row mt-3">
                    <div class="col-sm-6">
                        <div class="btn-group d-flex">
                            <button type="button" class="btn tertiary" :class="{'bg-dark lightest': (activeTab == number)}" v-for="(tab, number) in tabs" @click="changeTab(number)">{{tab}}</button>
                        </div>
                    </div>
                    <div class="col-sm-6">
                        <top-buttons :routes="getAllRoutes" :routeType="Number(activeTab)"></top-buttons>
                    </div>
                </div>
            <!-- </div> -->

            <div class="text-center" v-if="isLoadingRoutesFromApi">
                <loader></loader>
            </div>

            <div class="box shadowless mt-3">

                <div v-if="activeTab == 1" >
                    <route-holder :routes="getAllRoutes" :locationsList="locationsList" :routeType="1"></route-holder>
                </div>

                <div v-if="activeTab == 2" >
                    <route-holder :routes="getAllRoutes" :locationsList="locationsList" :routeType="2"></route-holder>
                </div>

                <div v-if="activeTab == 3" >
                    <div class="col-md-6">
                        <div class="row" v-if="getCompanySettings.settingsPresets">
                            <div class="darker fs-small font-weight-600">Type a message to users know what to do for custom pickups.</div>
                            <textarea class="mt-2 bg-lighter" v-model="getCompanySettings.settingsPresets.customRouteNote"></textarea>
                            <div class="mt-2 w-100 d-flex justify-content-end">
                                <button class="btn" @click="saveCustomMessage">Save</button>
                            </div>
                        </div>
                        <div class="row" v-else>
                            <div class="col-sm-12 text-center dark fs-large p-3 font-weight-600">
                                Loading
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- <div class="d-flex darker">
            <div class="col-md-6">

                <div class="fs-large border-bottom-dark py-2 font-weight-600">
                    Pickup Lists
                </div>

                <route-holder :routes="routes" :locationsList="locationsList" :routeType="1"></route-holder>
            </div>
            <div class="col-md-6">

                <div class=" fs-large border-bottom-dark py-2 font-weight-600">
                    Drop off Lists
                </div>

                <route-holder :routes="routes" :locationsList="locationsList" :routeType="2"></route-holder>
            </div>
        </div> -->
    </div>
</template>

<script>
import draggable from 'vuedraggable'
import {mapGetters, mapActions} from 'vuex'
import Timepicker from '@/tools/Timepicker'
import extendedVSelect from '@/extends/vue-select'
import Loader from '@/tools/loaders/loader1'
import {eventHub} from '../../../main'

import RouteHolder from './RoutesHolder'
import TopButtons from './TopButtons'

export default {
    data: function() {
        return {
            activeTab: 1,
            tabs: {
                1: 'Pickups',
                2: 'Dropoffs',
                3: 'Custom',
            },
            isLoadingRoutesFromApi: false,
            draggableOptions: {
                draggable:'.stopRow',
                animation: 200,
            },
            emptySchedule: {
                //date: "12-12-2018",
                // id: null,
                lap: 1,
                time: "00:00:00",
                timeShort: "00:00"
            },
            emptyStop: {
                // id: null,
                order: 1,
                schedules: [],
                stop: {
                    description: null,
                    // id: null,
                    name: ''
                }
            }
        }
    },
    created: function() {
        //we need supplier preset for the custom transpor messge, if we dont have that info we will init it
        if(!this.getCompanySettings.settingsPresets){
            this.initCompany()
        }


        this.downloadLocations()

        // this allows the manage location popup to trigger a refresh on this component
        eventHub.$on('updateTransportLocations',(date) => {
            this.downloadLocations()
        });
    },
    computed: {
        ...mapGetters([
            'account',
            'getCompanySettings',
            'getIsLoadingRoutes',
            'getAllRoutes',
            'getAllLocations'
        ]),
        locationsList: function () {
            return this.getAllLocations? this.getAllLocations : []
        },
    },
    asyncComputed: {
    },
    methods: {
        ...mapActions([
            'createRoute',
            'editRoute',
            'deleteRoute',
            'refreshAccountData',
            'initCompany',
            'saveSettingsPresets',
            'downloadLocations'
        ]),
        changeTab: function(tab) {
            this.activeTab = tab;
        },
        editRouteName: function(route) {
            if(route.editingName !== undefined){
                route.editingName = !route.editingName
            } else {
                this.$set(route, 'editingName', true);
            }
        },
        expandRoute: function(route) {
            if(route.expanded !== undefined){
                route.expanded = !route.expanded
            } else {
                this.$set(route, 'expanded', true);
            }
        },
        removeStop: function(itenerariesArr, index) {
            itenerariesArr.splice(index, 1);
        },
        saveRoute: function(route) {
            if(route.id){
                //updates existing route
                this.editRoute(route)
            } else {
                // creates new route
                this.createRoute(route)

            }
        },
        askDeleteRoute: function(routes, index) {
            let vm = this;
            this.$dialog.confirm('Delete route?')
            .then(function () {
                vm.deleteRoute(routes[index]).then(response => {
                    routes.splice(index, 1)
                })
            })
            .catch(function () {
            });
        },
        addTimeToRoute: function(route) {
            for(let itinerary of route.iteneraries){
                itinerary.schedules.push(JSON.parse(JSON.stringify(this.emptySchedule)))
            }
        },
        setTimeToPicker: function(timeString) {
            //receives 15:33
            let timeArr = timeString.split(':')
            return timeArr
        },
        changeTime: function(newTime, time) {
            time.time = newTime+":00"
            time.timeShort = newTime
        },
        deleteTimeRow: function(route, index) {
            this.$dialog.confirm('Are you sure you whant to delete the entire column of times?')
            .then(function () {
                for(let itinerary of route.iteneraries){
                    itinerary.schedules.splice(index, 1)
                }
            })
            .catch(function () {
            });
        },
        onMoveCallback: function(route) {
            route.iteneraries.map((itinerary, index) => {
                itinerary.order = index + 1
            })
        },
        addStop: function(route) {
            if(route.iteneraries == null){
                route.iteneraries = []
            }
            let emptyStop = JSON.parse(JSON.stringify(this.emptyStop));
            emptyStop.stop = this.locationsList[0]
            if(route.iteneraries && route.iteneraries.length > 0) {
                emptyStop.order = route.iteneraries.length + 1;
                for (var i = 0; i < route.iteneraries[0].schedules.length; i++) {
                    emptyStop.schedules.push(JSON.parse(JSON.stringify(this.emptySchedule)))
                }
            } else {
                emptyStop.schedules.push(JSON.parse(JSON.stringify(this.emptySchedule)))
            }
            route.iteneraries.push(emptyStop)
        },
        saveCustomMessage: function() {
            this.saveSettingsPresets(this.getCompanySettings.settingsPresets).then(response => {
            })
        }
    },
    components: {
        Timepicker,
        draggable,
        vSelect: extendedVSelect,
        RouteHolder,
        TopButtons,
        Loader
    }
}
</script>

<style lang="scss" scoped="">
@import '../../../assets/scss/_variables.scss';

.scrollMe{
    overflow: auto;
}

//tabs
.tabs {
    > ul {
        font-size: $font-size-small;
        background-color: $lightest;
        color: $dark;
        // margin: 0;
        border-top: 1px solid $light;

        > li {
            display: inline-block;
            height: 3rem;
            line-height: 3rem;
            padding: 0 1.5rem;
            cursor: pointer;

            &.active {
                color: $darker;
                border-bottom: 3px solid $brand;
            }
        }
    }

    .event-tab {
        font-size: $font-size-small;
        color: $darker;

        .table {
            th {
                color: $dark;
            }
        }

        .info {
            border-bottom: 1px solid $light;

            > li {
                line-height: 2em;

                > span {
                    display: inline-block;
                    width: 40%;
                    color: $dark;
                }
            }
        }

        .highlights {
            display: flex;
            border-radius: 4px;
            border: 1px solid $medium;

            > div {
                flex: 1;
                padding: 0.5rem 0.75rem;

                &:not(:first-child) {
                    border-left: 1px solid $medium;
                }

                h1 {
                    margin-bottom: 1.5rem;
                }

                .completed {
                    margin-top: 2rem;
                }
            }
        }
    }
}

</style>



// WEBPACK FOOTER //
// Transports.vue?5441292a